import { render, staticRenderFns } from "./RegisterServices.vue?vue&type=template&id=10afbab0"
import script from "./RegisterServices.vue?vue&type=script&lang=js"
export * from "./RegisterServices.vue?vue&type=script&lang=js"
import style0 from "./RegisterServices.vue?vue&type=style&index=0&id=10afbab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports